import React, { useRef } from 'react';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ image }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'spotlight__inline-img x db p2 pt5--lg pb5--lg reveal',
        { revealed: isIntersected }
      )}
    >
      <img src={image.url} alt={image.alt ? image.alt : 'Eugenie Detroit'} />
    </section>
  );
};
